module.exports = __webpack_public_path__ + "img/rabbitmq.7d95e7e0.svg";